import axios from "../axios-instance";

import { getHeaders } from "./getHeaders";

export const getTicketTemplatesAsyncFunc = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
    return async () => [];
  }

  return (inputValue) =>
    axios
      .post("/EventReports/tickettemplates/list", null, {
        headers: getHeaders(user.token),
      })
      .then(({ data }) => {
        let options = [];

        if (data.result) {
          options = Object.keys(data.result)
            .map((key) => ({ label: data.result[key], value: key }))
            .filter(({ label }) =>
              label.toLowerCase().includes(inputValue.toLowerCase())
            );
        }
        return options;
      })
      .catch((e) => {
        console.log(e);
      });
};
